import 'isomorphic-fetch';
import fetchCheck from '../redux/middleware/fetchCheck';

const embedUrl = '/cms/data/v1/quicksight/embed-url';
const dashboardsListUrl = '/cms/data/v1/quicksight/dashboards';
const credentials = 'include';
const headers = { Accept: 'application/json', 'Content-Type': 'application/json' };

export const fetchQuickSightEmbedUrl = async dashboardId => {
  return fetch(`${embedUrl}?dashboardId=${dashboardId}`, { method: 'GET', credentials, headers })
    .then(res => fetchCheck(res))
    .then(res => res.json());
};

export const fetchQuickSightDashboardsList = async () => {
  return fetch(dashboardsListUrl, { method: 'GET', credentials, headers })
    .then(res => fetchCheck(res))
    .then(res => res.json());
};
